import { IAddress, AddressModel } from "../Address"
import { TenantUserFields } from "../TenantUserFields";
import { v4 as uuid } from "uuid";
import {Model} from "../base/Model";
import {Collection} from "../base/Collection";
import { HumanModel } from "./Human";

enum GenderEnum {
  female = "F",
  male = "M",
  other = "U",
}


export class PersonModel extends HumanModel  {

    constructor(data = null, usertype = null) {
        super(data, usertype);
        
        if(data) {
            this.createModel(data);
        }
    }
}